import axios from 'axios';
import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SUGGEST_SLOT = 'GET_SUGGEST_SLOT';
export const GET_SUGGEST_SLOT_SUCCESS = 'GET_SUGGEST_SLOT_SUCCESS';
export const GET_SUGGEST_SLOT_FAILURE = 'GET_SUGGEST_SLOT_FAILURE';

// Action Creators
export const getSuggestRequest = () => ({
  type: GET_SUGGEST_SLOT,
});

export const getSuggestSuccess = (users) => ({
  type: GET_SUGGEST_SLOT_SUCCESS,
  payload: users,
});

export const getSuggestFailure = (error) => ({
  type: GET_SUGGEST_SLOT_FAILURE,
  payload: error,
});

// Thunk Function
export const getSuggestSlotData = (external, date) => {
  return async (dispatch) => {
    dispatch(getSuggestRequest());
    try {
      const response = await getMethodWithToken(
        url?.getSuggestSlot + '?date=' + date
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSuggestSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getSuggestFailure(error?.message));
    }
  };
};
